// Moldura das telas do módulo RH: mesmo header/tema/lateral das telas de Estoque (componentes de
// components/estoque/ui.js), com a navegação do RH. No celular a lateral vira um drawer.
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChartColumn, ChevronLeft, ChevronRight, Eye, EyeOff, FilePen, ListChecks, Menu, Moon, Sun, UserPlus, Users, X } from "lucide-react";
import { palette, useIsMobile } from "../estoque/ui";
import { alternarValoresOcultos, useValoresOcultos } from "./valores";

const TELAS = [
  { path: "/rh/colaboradores", label: "Colaboradores", description: "Cadastro de pessoas e vínculos", icon: Users },
  { path: "/rh/colaboradores/novo", label: "Nova admissão", description: "Cadastrar pessoa e primeiro vínculo", icon: UserPlus },
  { path: "/rh/contratos-pj", label: "Contratos PJ", description: "Reajustes, troca de CNPJ e aditivos", icon: FilePen },
  { path: "/rh/desligamentos", label: "Desligamentos", description: "Dashboard de desligamentos", icon: ChartColumn },
  { path: "/rh/motivos", label: "Motivos", description: "Catálogo de motivos de desligamento", icon: ListChecks },
];

function NavLista({ C, collapsed, onNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  // Detalhe de um colaborador (/rh/colaboradores/:id) marca "Colaboradores"
  const ativa = TELAS.find((t) => t.path === location.pathname) ? location.pathname : "/rh/colaboradores";
  return (
    <nav style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {TELAS.map((item) => {
        const Icon = item.icon;
        const active = ativa === item.path;
        return (
          <button
            key={item.path}
            onClick={() => { navigate(item.path); onNavigate && onNavigate(); }}
            title={collapsed ? item.label : item.description}
            aria-current={active ? "page" : undefined}
            style={{
              display: "flex", alignItems: "center", gap: 10, width: "100%", minHeight: 40,
              padding: collapsed ? "9px 0" : "9px 12px", justifyContent: collapsed ? "center" : "flex-start",
              borderRadius: 8, border: "none", cursor: "pointer", fontFamily: "inherit", textAlign: "left",
              background: active ? C.bgActive : "transparent",
              borderLeft: active ? `3px solid ${C.brand}` : "3px solid transparent",
              color: active ? C.brand : C.text, fontSize: 13, fontWeight: active ? 700 : 500,
            }}
          >
            <Icon size={17} style={{ flexShrink: 0 }} />
            {!collapsed && <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.label}</span>}
          </button>
        );
      })}
    </nav>
  );
}

export default function RhLayout({ titulo, isLight, setIsLight, acoesHeader, children }) {
  const C = palette(isLight);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerAberto, setDrawerAberto] = useState(false);
  const valoresOcultos = useValoresOcultos();

  const headerBtn = {
    display: "flex", alignItems: "center", gap: 6, background: "rgba(255,255,255,0.12)",
    border: "1px solid rgba(255,255,255,0.25)", borderRadius: 8, padding: "8px 10px", minHeight: 38,
    cursor: "pointer", color: "#fff", fontSize: 12, fontWeight: 600, fontFamily: "inherit",
  };
  const largura = collapsed ? 64 : 220;

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: C.bg, fontFamily: "'DM Sans', sans-serif", color: C.text }}>
      {!isMobile && (
        <aside style={{ width: largura, minWidth: largura, height: "100vh", position: "sticky", top: 0, background: C.card, borderRight: `1px solid ${C.border}`, display: "flex", flexDirection: "column", transition: "width 0.2s, min-width 0.2s" }}>
          <div style={{ padding: collapsed ? "18px 0" : "18px 16px", borderBottom: `1px solid ${C.border}`, minHeight: 62, display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "flex-start", gap: 8 }}>
            <div style={{ width: 30, height: 30, borderRadius: 8, background: C.brand, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Users size={15} color="#fff" />
            </div>
            {!collapsed && (
              <div>
                <div style={{ fontSize: 13, fontWeight: 700 }}>YOUX GROUP</div>
                <div style={{ fontSize: 10, color: C.muted, fontWeight: 500 }}>Pessoas & Cultura</div>
              </div>
            )}
          </div>
          <div style={{ flex: 1, overflowY: "auto", padding: "10px 8px" }}>
            <NavLista C={C} collapsed={collapsed} />
          </div>
          <div style={{ borderTop: `1px solid ${C.border}`, padding: "10px 8px" }}>
            <button onClick={() => setCollapsed((v) => !v)} style={{ display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "flex-start", gap: 8, width: "100%", padding: "9px 10px", borderRadius: 8, border: "none", background: "transparent", cursor: "pointer", color: C.muted, fontSize: 12, fontFamily: "inherit" }}>
              {collapsed ? <ChevronRight size={16} /> : <><ChevronLeft size={16} /><span>Recolher</span></>}
            </button>
          </div>
        </aside>
      )}

      {isMobile && drawerAberto && (
        <div onClick={() => setDrawerAberto(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 70 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ width: 270, height: "100%", background: C.card, padding: 12, display: "flex", flexDirection: "column", gap: 12, overflowY: "auto", boxSizing: "border-box" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 4px 8px", borderBottom: `1px solid ${C.border}` }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>Pessoas & Cultura</span>
              <button onClick={() => setDrawerAberto(false)} aria-label="Fechar menu" style={{ background: "none", border: "none", color: C.muted, cursor: "pointer", display: "flex", padding: 6 }}>
                <X size={20} />
              </button>
            </div>
            <NavLista C={C} collapsed={false} onNavigate={() => setDrawerAberto(false)} />
            <button onClick={() => navigate("/inicio")} style={{ marginTop: "auto", minHeight: 44, borderRadius: 8, border: `1px solid ${C.border}`, background: "transparent", color: C.text, fontSize: 13, fontWeight: 600, fontFamily: "inherit", cursor: "pointer" }}>
              Menu Principal
            </button>
          </div>
        </div>
      )}

      <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <header style={{ background: "linear-gradient(to right, #581c87, #9d174d)", color: "#fff", padding: isMobile ? "10px 12px" : "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, position: "sticky", top: 0, zIndex: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
            {isMobile && (
              <button onClick={() => setDrawerAberto(true)} aria-label="Abrir menu" style={{ ...headerBtn, padding: 8 }}>
                <Menu size={18} />
              </button>
            )}
            {!isMobile && (
              <>
                <span style={{ fontSize: 22, fontWeight: 800 }}>YOUX</span>
                <span style={{ fontSize: 18, fontWeight: 300 }}>GROUP</span>
              </>
            )}
            <span style={{ fontSize: isMobile ? 15 : 13, fontWeight: isMobile ? 700 : 500, opacity: isMobile ? 1 : 0.8, marginLeft: isMobile ? 0 : 8, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {isMobile ? titulo : `· ${titulo}`}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {acoesHeader}
            <button onClick={alternarValoresOcultos} style={headerBtn} aria-pressed={valoresOcultos}
              aria-label={valoresOcultos ? "Mostrar valores" : "Ocultar valores"} title={valoresOcultos ? "Mostrar valores" : "Ocultar valores"}>
              {valoresOcultos ? <EyeOff size={14} /> : <Eye size={14} />}
            </button>
            <button onClick={() => setIsLight((l) => !l)} style={headerBtn} aria-label="Alternar tema">
              {isLight ? <Moon size={14} /> : <Sun size={14} />}
            </button>
            {!isMobile && <button onClick={() => navigate("/inicio")} style={headerBtn}>Menu Principal</button>}
          </div>
        </header>
        <main style={{ flex: 1, padding: isMobile ? 12 : 24, minWidth: 0 }}>{children}</main>
      </div>
    </div>
  );
}
